import { styled } from '@mui/material'

import { BaseContainer } from '../../config/styles/BaseGrid'

export const Image404 = styled('img')`
  display: block;
  height: auto;
  margin: 0 auto;
  max-width: 100%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;

  ${props => props.theme.breakpoints.up('sm')} {
    width: 85%;
  }

  ${props => props.theme.breakpoints.up('md')} {
    width: 75%;
  }
`

export const Root = styled(BaseContainer)`
  align-items: center;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  margin: 0 auto;
`
